import HNSColors from "../../../ui library/HNSColors";

export const getButtonsConfig = (additionalDetails) => ({
  CANCEL: {
    label: "Cancel",
    onClick: additionalDetails.handleCancel,
    variant: "outlined",
    sx: {
      border: "1px solid",
      backgroundColor: HNSColors.neutrals[900],
      color: HNSColors.failure[500],
      borderColor: HNSColors.failure[500],
      "&:hover": {
        backgroundColor: HNSColors.failure[700],
        color: HNSColors.failure[900],
        borderColor: HNSColors.neutrals[900],
      },
    },
  },
  DELETE: {
    label: "Delete Note",
    onClick: additionalDetails.handleDelete,
    sx: {
      backgroundColor: HNSColors.failure[500],
      color: HNSColors.neutrals[900],
      "&:hover": {
        backgroundColor: HNSColors.failure[600],
        color: HNSColors.neutrals[900],
      },
    },
  },
  BACK: {
    label: "Go Back",
    onClick: additionalDetails.handleFailure,
    sx: {
      backgroundColor: HNSColors.secondary[500],
      color: HNSColors.neutrals[900],
      "&:hover": {
        backgroundColor: HNSColors.secondary[600],
        color: HNSColors.neutrals[900],
      },
    },
  },
  OK: {
    label: "Ok",
    onClick: additionalDetails.handleSuccess,
    sx: {
      backgroundColor: HNSColors.secondary[500],
      color: HNSColors.neutrals[900],
      "&:hover": {
        backgroundColor: HNSColors.secondary[600],
        color: HNSColors.neutrals[900],
      },
    },
  },
});
